import React from 'react';
import {
  FaInstagram,
  FaWhatsapp,
  FaTiktok,
  FaFacebookF,
  FaXTwitter
} from 'react-icons/fa6'; // use Fa6 for TikTok and X

const SocialShareBarComponent = ({ message }) => {
  const encodedMessage = encodeURIComponent(message);

  return (
    <div className="social-share-bar">
      <a href='https://instagram.com' target="_blank" rel="noopener noreferrer">
        <FaInstagram />
      </a>
      <div className="divider" />
      <a href={`https://wa.me/?text=${encodedMessage}`} target="_blank" rel="noopener noreferrer">
        <FaWhatsapp />
      </a>
      <div className="divider" />
      <a href='https://www.tiktok.com' target="_blank" rel="noopener noreferrer">
        <FaTiktok />
      </a>
      <div className="divider" />
      <a href={`https://facebook.com/sharer/sharer.php?u=${encodedMessage}`} target="_blank" rel="noopener noreferrer">
        <FaFacebookF />
      </a>
      <div className="divider" />
      <a href={`https://twitter.com/intent/tweet?text=${encodedMessage}`} target="_blank" rel="noopener noreferrer">
        <FaXTwitter />
      </a>
    </div>
  );
};

export default SocialShareBarComponent;
